import { Capacitor } from '@capacitor/core';
import { Haptics, ImpactStyle } from '@capacitor/haptics';

let enabled = true;

/** 设置页的震动开关（存档 settings.haptics）；关掉后 tapFeedback 什么都不做 */
export function setHapticsEnabled(on: boolean): void {
  enabled = on;
}

/** 轻触反馈：App 内用 Capacitor Haptics（iOS Taptic / Android 振动），网页用 navigator.vibrate（iOS Safari 无效）。 */
export function tapFeedback(): void {
  if (!enabled) return;
  if (Capacitor.isNativePlatform()) {
    Haptics.impact({ style: ImpactStyle.Light }).catch(() => {
      /* 设备不支持时静默 */
    });
    return;
  }
  try {
    navigator.vibrate?.(15);
  } catch {
    // 不支持时静默
  }
}
